import { PayoutStatusFilter } from './Constants'

export type PayoutBadgeStatus =
  | 'awaitingConfirmation'
  | 'pending'
  | 'complete'
  | 'expired'
  | 'processing'
  | 'inReview'
  | 'failed'

const payoutStatusLabels: Record<string, string> = {
  AwaitingConfirmation: 'Awaiting confirmation',
  Pending: 'Pending',
  Processing: 'Processing',
  Complete: 'Completed',
  Expired: 'Expired',
  InReview: 'In review',
  Failed: 'Failed'
}

const payoutStatusDescriptions: Record<string, string> = {
  AwaitingConfirmation: 'Review and confirm this payout before funds move.',
  Pending: 'Accepted and waiting for funding or banking rail submission.',
  Processing: 'Submitted to the payout rail and awaiting final confirmation.',
  Complete: 'Paid out successfully.',
  Expired: 'Confirmation window expired before funds moved.',
  InReview: 'Held for a compliance check on the recipient.',
  Failed: 'Payout failed and needs review.'
}

const payoutBadgeStatuses: Record<string, PayoutBadgeStatus> = {
  AwaitingConfirmation: 'awaitingConfirmation',
  Pending: 'pending',
  Processing: 'processing',
  Complete: 'complete',
  Expired: 'expired',
  InReview: 'inReview',
  Failed: 'failed'
}

export const payoutStatusOptions: PayoutStatusFilter[] = [
  PayoutStatusFilter.AwaitingConfirmation,
  PayoutStatusFilter.Pending,
  PayoutStatusFilter.Processing,
  PayoutStatusFilter.Complete,
  PayoutStatusFilter.Expired,
  PayoutStatusFilter.InReview,
  PayoutStatusFilter.Failed
]

export const payoutStatusLabel = (status: string): string => payoutStatusLabels[status] ?? status

export const payoutStatusDescription = (status: string): string =>
  payoutStatusDescriptions[status] ?? 'Status update unavailable.'

export const payoutBadgeStatus = (status: string): PayoutBadgeStatus =>
  payoutBadgeStatuses[status] ?? 'pending'
